<template>
  <div>
    <v-text-field
      hide-details
      v-model="searchString"
      v-bind:placeholder="$t('start_typing_to_search')"
      @input="searchItems"
    ></v-text-field>
    <div class="loading-spinner text-center mt-2 mb-2" v-if="isDataLoading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div class="list_options" v-if="filteredList.length > 0">
      <v-checkbox
        v-for="item in filteredList"
        :key="item.id"
        v-model="filterCriteria[item.id]"
        :label="item.title"
        :value="item.id"
      ></v-checkbox>
    </div>
    <div v-else class="text-center">{{ $t("Empty data") }}</div>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";

export default {
  name: "dynamicStateFilter",
  props: [
    "value",
    "townFilter" // Pass the town filter to determine which API to use
  ],
  data: function() {
    return {
      isDataLoading: false,
      searchString: "",
      filteredList: []
    };
  },
  watch: {
    filterCriteria(newVal, oldVal) {
      if (Object.keys(newVal).length === 0) {
        this.setSearchString("");
      }
    },
    townFilter: {
      handler(newVal, oldVal) {
        // When town filter changes, refresh the state data
        this.getDataFromApi(this.searchString);
      },
      deep: true
    }
  },
  computed: {
    filterCriteria: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    hasTownFilter() {
      // Check if town filter has any selected values
      return this.townFilter && Object.keys(this.townFilter).length > 0 && 
             Object.values(this.townFilter).some(val => val);
    }
  },
  methods: {
    setSearchString(str) {
      this.searchString = str;
      this.getDataFromApi(this.searchString);
    },
    async searchItems() {
      this.getDataFromApi(this.searchString);
    },
    async getDataFromApi(searchString) {
      this.isDataLoading = true;
      try {
        let response;
        let filteredResults = [];
        
        if (this.hasTownFilter) {
          // Use the new API when towns are selected
          const filterModel = [{
            columnField: "town",
            filterValue: this.townFilter
          }];
          
          response = await ApiService.get('pos/get_states_by_cities', {
            params: {
              filterModel: JSON.stringify(filterModel)
            }
          });
          
          if (response.data && response.success) {
            filteredResults = response.data;
          } else {
            filteredResults = [];
          }
          
          // Apply search string filtering on the client side if searchString is provided
          if (searchString && searchString.trim() !== '') {
            filteredResults = filteredResults.filter(item => 
              item.title && item.title.toLowerCase().includes(searchString.toLowerCase())
            );
          }
          
          this.filteredList = filteredResults;
        } else {
          // Use the original API when no towns are selected
          let fetch_url = `pos/getfilterlist?column=state_name&filterValue=${searchString}&isFullText=true`;
          response = await ApiService.get(fetch_url);
          
          if (response.data) {
            this.filteredList = response.data;
          } else {
            this.filteredList = [];
          }
        }
        
        this.isDataLoading = false;
      } catch (error) {
        logError(error);
        this.filteredList = [];
        this.isDataLoading = false;
      }
    },
    init() {
      this.getDataFromApi("");
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style>
.list_options {
  max-height: 300px;
  overflow-y: scroll;
}
.list_options .v-input--selection-controls {
  margin-top: 5px;
}
</style>
